// EIP-712 typed-data builders for RE₿EL Governance (gas-free signed votes).
// MUST stay byte-identical to the backend definition in routes/governance.py.
export const RBL_CONTRACT = "0xf9214b42c4c53791846E90066E52D7306adFACf5";

export const GOVERNANCE_DOMAIN = {
  name: "RE₿EL Governance",
  version: "1",
  chainId: 8453, // Base L2
  verifyingContract: RBL_CONTRACT,
};

export const VOTE_TYPES = {
  Vote: [
    { name: "proposalId", type: "string" },
    { name: "vote", type: "string" },
    { name: "voter", type: "address" },
    { name: "timestamp", type: "uint256" },
  ],
};

export const PROPOSAL_TYPES = {
  Proposal: [
    { name: "title", type: "string" },
    { name: "proposer", type: "address" },
    { name: "timestamp", type: "uint256" },
  ],
};

export const buildVoteTypedData = (proposalId, vote, voter) => {
  const timestamp = Math.floor(Date.now() / 1000);
  return {
    timestamp,
    typedData: {
      domain: GOVERNANCE_DOMAIN,
      types: VOTE_TYPES,
      primaryType: "Vote",
      message: { proposalId, vote, voter, timestamp: BigInt(timestamp) },
    },
  };
};

export const buildProposalTypedData = (title, proposer) => {
  const timestamp = Math.floor(Date.now() / 1000);
  return {
    timestamp,
    typedData: {
      domain: GOVERNANCE_DOMAIN,
      types: PROPOSAL_TYPES,
      primaryType: "Proposal",
      message: { title, proposer, timestamp: BigInt(timestamp) },
    },
  };
};

export const GOV_PARAMS = {
  MIN_VOTE_RBL: 10000,
  MIN_PROPOSE_RBL: 500000,
  QUORUM_RBL: 10000000,
  DURATIONS: [3, 7, 14],
};
